import React, { useEffect, useRef } from 'react';
function useScrollReveal(delay = 0) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(40px)';
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        }, delay);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [delay]);
  return ref;
}
export function ServicesTable() {
  const headerRef = useScrollReveal(0);
  const tableRef = useScrollReveal(200);
  return <section className="w-full py-20 sm:py-28" style={{
    backgroundColor: '#0f0f0f'
  }} aria-label="Our services" data-id="element-474">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-475">
        <div ref={headerRef} data-id="element-476">
          <div className="flex items-center gap-3 mb-6" data-id="element-477">
            <div style={{
            width: '40px',
            height: '1px',
            background: '#C9A84C'
          }} data-id="element-478" />
            <span className="section-label" data-id="element-479">What We Do</span>
          </div>
          <h2 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
          fontWeight: 700,
          color: '#F5F5F5',
          lineHeight: 1.2,
          marginBottom: '1rem'
        }} data-id="element-480">
            We Do It All —{' '}
            <span style={{
            color: '#C9A84C',
            fontStyle: 'italic'
          }} data-id="element-481">
              And We Do It Right
            </span>
          </h2>
          <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: '1.05rem',
          color: '#888',
          lineHeight: 1.7,
          marginBottom: '3rem'
        }} data-id="element-482">
            Our barbers are trained in the full range of men's and boys'
            grooming. No faking. No guessing.
          </p>
        </div>

        <div ref={tableRef} data-id="element-483">
          {/* Desktop table */}
          <div className="hidden sm:block overflow-hidden rounded-sm" style={{
          border: '1px solid rgba(201,168,76,0.2)'
        }} data-id="element-484">
            <table className="w-full" role="table" aria-label="Services offered at By Guerra Barbershop" data-id="element-485">
              <thead data-id="element-486">
                <tr style={{
                backgroundColor: '#111111',
                borderBottom: '1px solid rgba(201,168,76,0.3)'
              }} data-id="element-487">
                  <th className="text-left px-6 py-4" style={{
                  fontFamily: 'var(--font-callout)',
                  fontSize: '0.8rem',
                  letterSpacing: '0.15em',
                  textTransform: 'uppercase',
                  color: '#C9A84C',
                  fontWeight: 600
                }} data-id="element-488">
                    Service
                  </th>
                  <th className="text-left px-6 py-4" style={{
                  fontFamily: 'var(--font-callout)',
                  fontSize: '0.8rem',
                  letterSpacing: '0.15em',
                  textTransform: 'uppercase',
                  color: '#C9A84C',
                  fontWeight: 600
                }} data-id="element-489">
                    What You Get
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-490">
                <ServiceRow service="Custom Cut" description="Tailored to your face shape, your style, your preferences" dark data-id="element-491" />
                <ServiceRow service="Fade (All Levels)" description="Low, mid, high — clean, crisp, precise every time" data-id="element-492" />
                <ServiceRow service="Buzz Cut" description="Clean and even from edge to edge" dark data-id="element-493" />
                <ServiceRow service="Scissor Cut" description="Old-school technique, modern results" data-id="element-494" />
                <ServiceRow service="Shape Up" description="Crisp lines that frame your face like they should" dark data-id="element-495" />
                <ServiceRow service="Curly Styles" description="We work with your texture, not against it" data-id="element-496" />
                <ServiceRow service="Beard Trim" description="Defined lines, balanced shape, looking intentional" dark data-id="element-497" />
                <ServiceRow service="Beard Conditioning" description="Soft, healthy, groomed — not scratchy and wild" data-id="element-498" />
                <ServiceRow service="Kids' Cuts" description="Patient, skilled, kid-friendly — parents breathe easy" dark data-id="element-499" />
                <ServiceRow service="Long Styles" description="Men with longer hair finally get the care they deserve" data-id="element-500" />
                <ServiceRow service="Full Shave" description="The classic experience. Blade, hot towel, clean finish." dark data-id="element-501" />
              </tbody>
            </table>
          </div>

          {/* Mobile cards */}
          <div className="sm:hidden space-y-3" data-id="element-502">
            <MobileServiceCard service="Custom Cut" description="Tailored to your face shape, your style, your preferences" data-id="element-503" />
            <MobileServiceCard service="Fade (All Levels)" description="Low, mid, high — clean, crisp, precise every time" data-id="element-504" />
            <MobileServiceCard service="Buzz Cut" description="Clean and even from edge to edge" data-id="element-505" />
            <MobileServiceCard service="Scissor Cut" description="Old-school technique, modern results" data-id="element-506" />
            <MobileServiceCard service="Shape Up" description="Crisp lines that frame your face like they should" data-id="element-507" />
            <MobileServiceCard service="Curly Styles" description="We work with your texture, not against it" data-id="element-508" />
            <MobileServiceCard service="Beard Trim" description="Defined lines, balanced shape, looking intentional" data-id="element-509" />
            <MobileServiceCard service="Beard Conditioning" description="Soft, healthy, groomed — not scratchy and wild" data-id="element-510" />
            <MobileServiceCard service="Kids' Cuts" description="Patient, skilled, kid-friendly — parents breathe easy" data-id="element-511" />
            <MobileServiceCard service="Long Styles" description="Men with longer hair finally get the care they deserve" data-id="element-512" />
            <MobileServiceCard service="Full Shave" description="The classic experience. Blade, hot towel, clean finish." data-id="element-513" />
          </div>
        </div>
      </div>
    </section>;
}
function ServiceRow({
  service,
  description,
  dark
}: {
  service: string;
  description: string;
  dark?: boolean;
}) {
  return <tr style={{
    backgroundColor: dark ? '#111111' : '#0f0f0f',
    borderBottom: '1px solid rgba(201,168,76,0.08)'
  }} data-id="element-514">
      <td className="px-6 py-4" data-id="element-515">
        <div className="flex items-center gap-3" data-id="element-516">
          <div style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          backgroundColor: '#C9A84C',
          flexShrink: 0
        }} data-id="element-517" />
          <span style={{
          fontFamily: 'var(--font-callout)',
          fontSize: '1rem',
          fontWeight: 600,
          color: '#F5F5F5',
          letterSpacing: '0.03em'
        }} data-id="element-518">
            {service}
          </span>
        </div>
      </td>
      <td className="px-6 py-4" data-id="element-519">
        <span style={{
        fontFamily: 'var(--font-body)',
        fontSize: '0.95rem',
        color: '#888',
        lineHeight: 1.5
      }} data-id="element-520">
          {description}
        </span>
      </td>
    </tr>;
}
function MobileServiceCard({
  service,
  description
}: {
  service: string;
  description: string;
}) {
  return <div className="p-4 rounded-sm" style={{
    backgroundColor: '#111111',
    border: '1px solid rgba(201,168,76,0.15)'
  }} data-id="element-521">
      <div className="flex items-center gap-2 mb-1" data-id="element-522">
        <div style={{
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        backgroundColor: '#C9A84C',
        flexShrink: 0
      }} data-id="element-523" />
        <span style={{
        fontFamily: 'var(--font-callout)',
        fontSize: '1rem',
        fontWeight: 600,
        color: '#F5F5F5',
        letterSpacing: '0.03em'
      }} data-id="element-524">
          {service}
        </span>
      </div>
      <p style={{
      fontFamily: 'var(--font-body)',
      fontSize: '0.9rem',
      color: '#888',
      lineHeight: 1.5,
      paddingLeft: '14px'
    }} data-id="element-525">
        {description}
      </p>
    </div>;
}